import tippy from 'tippy.js';
import 'tippy.js/themes/light.css';
import 'tippy.js/dist/tippy.css'; // optional for styling

var circleInstance = new tippy('.resource-circle-link.has-tippy', {
    allowHTML: true,
    arrow: true,
    content: (reference) => reference.getAttribute('data-tippy-content'),
    interactive: false,
    theme: 'light',
    placement: 'auto',
});

var memberInstance = new tippy('.member-link.has-tippy', {
    allowHTML: true,
    arrow: true,
    content: (reference) => reference.getAttribute('data-tippy-content'),
    interactive: false,
    theme: 'light',
    placement: 'auto',
});
